import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { routerReducer } from '@ngrx/router-store';
import { META_REDUCERS, StoreModule } from '@ngrx/store';

import { AppStoreModule } from './app/app.module';
import { ChecklistStoreModule } from './checklist/checklist.module';
import { ChecklistListStoreModule } from './checklist-list/checklist-list.module';
import { ConversationStoreModule } from './conversation/conversation.module';
import { DatapointFieldStoreModule } from './datapoint-field/datapoint-field.module';
import { DatapointFieldListStoreModule } from './datapoint-field-list/datapoint-field-list.module';
import { DatapointLookupStoreModule } from './datapoint-lookup/datapoint-lookup.module';
import { DealStoreModule } from './deal/deal.module';
import { DealComparisonStoreModule } from './deal-comparison/deal-comparison.module';
import { DealFilterStoreModule } from './deal-filter/deal-filter.module';
import { DocumentListStoreModule } from './document-list/document-list.module';
import { DocumentViewerStoreModule } from './document-viewer/document-viewer.module';
import { EmbeddedStoreModule } from './embedded/embedded.module';
import { ExtractStoreModule } from './extract/extract.module';
import { ExtractionRuleStoreModule } from './extraction-rule/extraction-rule.module';
import { ExtractionRuleListStoreModule } from './extraction-rule-list/extraction-rule-list.module';
import { FormulaStoreModule } from './formula/formula.module';
import { FormulaListStoreModule } from './formula-list/formula-list.module';
import { HeadingStoreModule } from './heading/heading.module';
import { HomeStoreModule } from './home/home.module';
import { LabelStoreModule } from './label/label.module';
import { ManagerStoreModule } from './manager/manager.module';
import { MarketComparisonStoreModule } from './market-comparison/market-comparison.module';
import { changeAssetFactory } from './meta-reducers/change-asset.factory';
import { localStorageSyncFactory } from './meta-reducers/local-storage-sync.factory';
import { PanelStoreModule } from './panel/panel.module';
import { RootStoreEffects } from './root-store.effects';
import { SearchStoreModule } from './search/search.module';
import { SimilarParagraphStoreModule } from './similar-paragraphs/similar-paragraph.module';
import { SizeStoreModule } from './size/size.module';
import { TenantUserStoreModule } from './tenant-user/tenant-user.module';
import { TermExplorerStoreModule } from './term-explorer/term-explorer.module';
import { TopicStoreModule } from './topic/topic.module';
import { TopicListStoreModule } from './topic-list/topic-list.module';
import { TransactionStoreModule } from './transaction/transaction.module';
import { UserProfileStoreModule } from './user-profile/user-profile.module';

const storeModules = [
  AppStoreModule,
  ChecklistListStoreModule,
  ChecklistStoreModule,
  ConversationStoreModule,
  DatapointFieldListStoreModule,
  DatapointFieldStoreModule,
  DealComparisonStoreModule,
  DealFilterStoreModule,
  DealStoreModule,
  DocumentListStoreModule,
  DocumentViewerStoreModule,
  PanelStoreModule,
  EmbeddedStoreModule,
  ExtractionRuleListStoreModule,
  ExtractionRuleStoreModule,
  ExtractStoreModule,
  FormulaListStoreModule,
  FormulaStoreModule,
  HeadingStoreModule,
  HomeStoreModule,
  LabelStoreModule,
  ManagerStoreModule,
  MarketComparisonStoreModule,
  SearchStoreModule,
  SimilarParagraphStoreModule,
  SizeStoreModule,
  TermExplorerStoreModule,
  TenantUserStoreModule,
  TopicListStoreModule,
  TopicStoreModule,
  TransactionStoreModule,
  UserProfileStoreModule,
  DatapointLookupStoreModule,
];

@NgModule({
  declarations: [],
  imports: [CommonModule, ...storeModules, StoreModule.forRoot({ router: routerReducer }), EffectsModule.forRoot([RootStoreEffects])],
  providers: [
    {
      provide: META_REDUCERS,
      deps: [],
      useFactory: localStorageSyncFactory,
      multi: true,
    },
    {
      provide: META_REDUCERS,
      deps: [],
      useFactory: changeAssetFactory,
      multi: true,
    },
  ],
})
export class RootStoreModule {}
